import React from "react";
import Tabla from "./Tabla";
import Loading from "../../../components/Loading";
import auth_icon from "../../../assets/vw/svg/autentificacion.svg";
import ARCH from "../../../assets/vw/svg/archivo.svg";
import TablaArchivo from "./TablaInactivos";
import Menu from "../../../components/Menu";
import Modal from "../../../components/Modal";
import NoInfoScreen from "../../../components/Screens/NoInfoScreen";
class TipoAutenticacion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataOriginal:[],
      data: [],
      dataFiltradas: [],
      cargando: true,
      searchInput: "",
      option: "auth",
      dataInactivas:[],
      dataInactivasFiltradas:[],
      modal: {
        active: false,
        message: '',
        success: false
      },
    };
  }

  componentDidMount() {
    Promise.all([
      fetch(
        process.env.REACT_APP_URL_DTO_BACK + "tipoautenticacion?todos=todos",
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + this.props.servicio.getToken(),
            "Content-Type": "application/json",
          },
        }
      ).then(async (res) => {
        let response = await res.json();
        if (!res.ok) {
          throw new Error(response.mensaje);
        }
        return response;
      }),
    ])
      .then(([tiposAutenticacion]) => {
        const activas = tiposAutenticacion.mensaje.filter((autenticacion) => {
          return autenticacion.activo === 1;
        });
        this.setState({
          cargando: false,
          data: activas,
          dataOriginal: tiposAutenticacion.mensaje
        });
      })
      .catch((errorP) => {
        this.setState({ cargando: false, modal: {
          active: true,
          message: errorP.message,
          success: false
        } });
        console.error(errorP.stack || errorP);
      });
  }

  handleChange = (event) => {
    if (this.state.option === "archivo") {
      this.setState({ searchInput: event.target.value }, () => {
        this.globalSearchInactivas();
      });
    }else{
    this.setState({ searchInput: event.target.value }, () => {
      this.globalSearch();
    });}
  };

  globalSearch = () => {
    let { data, searchInput } = this.state;
    if (searchInput && searchInput !== "") {
      let dataFiltradas = data.filter((value) => {
        return (
          value.nombre.toLowerCase().includes(searchInput.toLowerCase()) ||
          value.idTipoAutenticacion
            .toString()
            .includes(searchInput.toLowerCase()) ||
          value.protocolo.toString().includes(searchInput.toLowerCase())
        );
      });
      this.setState({ dataFiltradas });
    } else {
      let dataFiltradas = [];
      this.setState({ dataFiltradas });
    }
  };

  globalSearchInactivas = () => {
    let { dataInactivas, searchInput } = this.state;
    if (searchInput && searchInput !== "") {
      let dataInactivasFiltradas = dataInactivas.filter((value) => {
        return (
          value.nombre.toLowerCase().includes(searchInput.toLowerCase()) ||
          value.idTipoAutenticacion.toString().includes(searchInput.toLowerCase()) ||
          value.protocolo.toString().includes(searchInput.toLowerCase())
        );
      });
      this.setState({ dataInactivasFiltradas });
    } else {
      let dataInactivasFiltradas = [];
      this.setState({ dataInactivasFiltradas });
    }
  };

  changeOption = (option) => {
    this.setState({ dataInactivas:[], dataInactivasFiltradas:[], dataFiltradas: [] });
    this.setState({ option });
    if (option === "archivo") {
      this.autenticacionInactivas(this.state.dataOriginal);
    }
  };

  autenticacionInactivas = (data) =>{
    const inactivas = data.filter((autenticacion) => {
      return autenticacion.activo === 0;
    });
    this.setState({ dataInactivas: inactivas });
  }
  render() {
    return (
      <>
      <Menu/>
      <Modal 
        modalInfo={this.state.modal} 
        setMostrarModal={(data) => {
          this.setState({ modal: data });
        }} 
      />
      {
        this.state.cargando && <Loading />
      }
      <div className={`navegacion`}>
      {this.state.dataOriginal.length > 0 ? (
          <>
            <div className=" posicionMenu">
              <ul className="d-flex flex-row px-0 my-0">
                <li
                  className="opcion-ruta"
                  onClick={() => this.changeOption("auth")}
                >
                  <div
                      className={`nav-link nav-link-title active ps-0 ${
                          this.state.option === "auth"
                              ? " active border_menu"
                              : ""
                      }`}
                  >
                    <img
                        src={auth_icon}
                        alt="destinatarios"
                        className="icono-menu me-3"
                    />
                    <span className={"nav-link-title-show--mobile"} style={{marginRight: '5px'}}>Tipo de</span>
                    <span className={"nav-link-title-one-word--mobile"}>autenticación</span>
                  </div>
                </li>
                <li
                    className="opcion-ruta"
                    onClick={() => this.changeOption("archivo")}
                >
                <div
                    className={`nav-link active ps-0  ${
                      this.state.option === "archivo"
                        ? " active border_menu"
                        : ""
                    }`}
                  >
                    <img src={ARCH} alt="archivo" className="icono-menu me-3" />
                    Archivo
                  </div>
                </li>
              </ul>
            </div>
            <div className="row border_vw pt-4 ms-0 mx-0">
              <div className="col-12 p-0 contenedor-table">
                {this.state.option === "archivo" ? (
                <TablaArchivo
                data={
                  this.state.dataInactivasFiltradas &&
                  this.state.dataInactivasFiltradas.length
                    ? this.state.dataInactivasFiltradas
                    : this.state.dataInactivas
                }
                servicio={this.props.servicio}
                marca={this.props.marca}
                handleChange={this.handleChange}
              ></TablaArchivo>
              ): (
                  <Tabla
                    data={
                      this.state.dataFiltradas &&
                      this.state.dataFiltradas.length
                        ? this.state.dataFiltradas
                        : this.state.data
                    }
                    servicio={this.props.servicio}
                    marca={this.props.marca}
                    handleChange={this.handleChange}
                  ></Tabla>
                ) }
              </div>
            </div>
          </>
        ) : (
          <>
            {
              !this.state.cargando && <NoInfoScreen />
            }
          </>
        )
      
      }
      </div>
      </>
    );
  }
}

export default TipoAutenticacion;
